<template>
    <div class="relative">
        <Handle
            v-for="position in positions"
            :key="position"
            type="target"
            :id="position"
            :position="position"
            class="absolute opacity-0"
            :style="handleStyle(position)"
        />


        <div
            class="w-24 h-24 shadow-lg  border-2 hover:border-blue-500 rounded-lg  bg-white"
            :class="{'border-blue-500': props.isHover, 'border-white': !props.isHover}"
        >
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M33.6402 15.3573C33.892 15.3573 34.0962 15.5615 34.0962 15.8133V23.9751C34.1015 25.0105 33.2702 25.8523 32.2363 25.8643L32.2337 25.8644H25.427C24.8876 25.8644 24.451 26.3009 24.451 26.8403H23.539V15.8293C23.539 15.5774 23.7431 15.3733 23.995 15.3733C24.2469 15.3733 24.451 15.5774 24.451 15.8293V25.2236C24.7358 25.0514 25.0698 24.9523 25.427 24.9523H32.2281C32.7614 24.9448 33.1872 24.511 33.1841 23.979L33.1841 23.9777V15.8133C33.1841 15.5615 33.3883 15.3573 33.6402 15.3573Z" fill="#b0bec4"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3498 14.3267C14.6017 14.3267 14.8059 14.5308 14.8059 14.7827V23.9909C14.8096 24.5281 15.2454 24.9577 15.7791 24.9546L15.7805 24.9546H22.578L22.5794 24.9546C23.619 24.9606 24.4563 25.8052 24.451 26.8438V30.1443C24.451 30.3961 24.2469 30.6003 23.995 30.6003C23.7431 30.6003 23.539 30.3961 23.539 30.1443V26.8413L23.539 26.8399C23.5421 26.3062 23.1125 25.8704 22.5753 25.8667H15.783C14.7444 25.8719 13.8998 25.0346 13.8938 23.995L13.8938 23.9937V14.7827C13.8938 14.5308 14.098 14.3267 14.3498 14.3267Z" fill="#b0bec4"></path>
                <path d="M27.7414 33.9274C27.7414 35.9773 26.0814 37.6372 24.0315 37.6372C21.9816 37.6372 20.3217 35.9773 20.3217 33.9274C20.3217 31.8775 21.9816 30.2175 24.0315 30.2175C26.0814 30.2175 27.7414 31.8798 27.7414 33.9274Z" fill="#7fa0ad"></path>
                <path d="M27.7414 14.7099C27.7414 16.7597 26.0814 18.4197 24.0315 18.4197C21.9816 18.4197 20.3217 16.7597 20.3217 14.7099C20.3217 12.66 21.9816 11 24.0315 11C26.0814 11 27.7414 12.66 27.7414 14.7099Z" fill="#a9c9d6"></path>
                <path d="M18.0597 14.7099C18.0597 16.7597 16.3998 18.4197 14.3499 18.4197C12.3 18.4197 10.64 16.7597 10.64 14.7099C10.64 12.66 12.3 11 14.3499 11C16.3975 11 18.0597 12.66 18.0597 14.7099Z" fill="#a9c9d6"></path>
                <path d="M37.3523 14.7099C37.3523 16.7597 35.6924 18.4197 33.6425 18.4197C31.5926 18.4197 29.9326 16.7597 29.9326 14.7099C29.9326 12.66 31.5926 11 33.6425 11C35.6901 11 37.3523 12.66 37.3523 14.7099Z" fill="#a9c9d6"></path>
            </svg>
        </div>
        <div :title="label" class="absolute w-full flex items-center justify-center">
            {{ props.label }}
        </div>
    </div>

</template>

<script setup>
import { Position } from '@vue-flow/core'
import { Handle } from '@vue-flow/core'
import {defineProps} from 'vue'

const props = defineProps({
    label: String,
    isHover: Boolean,
})


const positions = [Position.Top, Position.Left, Position.Right, Position.Bottom]

const handleStyle = (position) => {
    const size = 0 // размер хендла
    const offset = -size / 2 // смещение для точного позиционирования

    switch(position) {
        case Position.Top: return { top: `${offset}px`, left: '50%', transform: 'translateX(-50%)' }
        case Position.Left: return { left: `${offset}px`, top: '50%', transform: 'translateY(-50%)' }
        case Position.Right: return { right: `${offset}px`, top: '50%', transform: 'translateY(-50%)' }
        case Position.Bottom: return { bottom: `${offset}px`, left: '50%', transform: 'translateX(-50%)' }
    }
}
</script>
